export default "__VITE_ASSET__DyrqAqos__"